export default {"src":"/_next/static/media/consultance.e7487be3.svg","height":37,"width":35,"blurWidth":0,"blurHeight":0};